









import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class VToolbar extends Vue {
  @Prop({ type: Boolean }) sticky?: boolean;
  @Prop({ default: "light" }) variant?: string;

  get className(): Record<string, boolean> {
    return {
      ...this.backgroundClassName,
      "sticky-top": !!this.sticky
    };
  }

  get backgroundClassName(): Record<string, boolean> {
    return Object.fromEntries([[`bg-${this.variant}`, true]]);
  }
}
